function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "mthujp6dya",
  d: "M0 0.485L12.515 0.485 12.515 13.001 0 13.001z"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(3 3)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "nnkkicpz2b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#mthujp6dya"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#7b7b7b",
  stroke: "#7b7b7b",
  strokeLinejoin: "round",
  strokeWidth: 1,
  d: "M7.105 6.743l5.235-5.235c.234-.234.234-.613 0-.847-.235-.235-.617-.235-.852 0l-5.23 5.234L1.023.661C.789.426.41.426.176.661c-.235.234-.235.613 0 .851L5.41 6.743l-5.234 5.23c-.235.235-.235.617 0 .852.117.117.269.176.426.176.152 0 .304-.059.421-.176L6.258 7.59l5.23 5.235c.121.117.274.176.426.176.152 0 .309-.059.426-.176.234-.235.234-.617 0-.852l-5.235-5.23z",
  mask: "url(#nnkkicpz2b)"
}));

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.87690051.svg";
export { ForwardRef as ReactComponent };